export const LICENCE_CONFIG_MAP = {
    "default": {
        "nane": "Luckera Casino",
        "logo-xmas": "assets/logo/lemon-logo-xmas-mobile.svg",
        "logo-desktop-xmas": "assets/logo/logo-xmas-desktop.svg",
        "logo": "assets/logo/logo-green.svg",
        "logo-desktop": "assets/luckera/desktop-logo-125x32.svg",
        "logo-mobile": "assets/luckera/desktop-logo.svg",
        // "logo-mobile" : "assets/logo/2024/logo-xmas-desktop.png",
        // "logo-desktop": "assets/logo/2024/logo-xmas-desktop.png",
        "full-logo": "assets/logo/logo-green.svg",
        "title-substitute": "",
        "icon-mission-logo": "assets/desktop/missions/tag-incomplete.svg",
        "bg-close": "assets/luckera/icons/bg-luckera-close.svg",
        "icon-mission-completed": "assets/desktop/missions/tag-completed.svg",
        "arrow-icon": "assets/desktop/yellow-arrow.svg",
        "arrow-icon-white":"assets/luckera/icons/white-bg-arrow.svg",
        "icon-edit-avater": "assets/icons/profile-edit-avater-button.svg",
        "icon-edit-no-outline-yellow": "assets/icons/icon-edit-no-outline-yellow.svg",
        "icon-edit-profile":"assets/luckera/icons/edit-profile-icon.svg",
        "icon-edit-profile-thick":"assets/luckera/icons/icon-edit-profile-thick.svg",
        "icon-adress": "assets/icons/adress.svg",
        "icon-edit-address":"assets/luckera/icons/icon-edit-address.svg",
        "icon-exclamation": "assets/icons/icon-exclamation.svg",
        "icon-upload": "assets/icons/icon-upload.svg",
        "upload-docs-icon": "assets/images/upload-docs.svg",
        "pending-withdrawal": "assets/images/pending-withdrawal.svg",
        "pending-withdrawal-luckera":"assets/luckera/signup/close.svg",
        "icon-vip-leef": "assets/icons/vip-leaves.svg",
        "icon-ham-btn": "assets/desktop/icon-ham-btn-white.svg",
        "icon-wallet-bonus-black": "assets/icons/wallet-bonus-icon.svg",
        "icon-password-lock": "assets/icons/icon-password-lock.svg",
        "icon-password-lock-luckera": "assets/luckera/icons/change-pswd-icon.svg",
        "icon-payment-not-available": "assets/icons/icon-not-available-payment.svg",
        "icon-bonus-drop": "assets/icons/pending-rewards-teaser.svg",
        "icon-copy": "assets/icons/icon-copy.svg",
        "icon-money-bag": "assets/icons/money-bag.svg",
        "icon-friends": "assets/icons/icon-friends.svg",
        "icon-avatar-friend": "assets/icons/icon-avatar-friend.png",
        "icon-tick-mark": "assets/icons/tick-mark.svg",
        "icon-reward-money-bag": "assets/icons/reward-money-bag.png",
        "icon-private": "assets/mobile/icon-private.svg",
        "icon-xmas-decor": "assets/icons/xmas/xmas-lemon-decor.png",
        "icon-xmas-lemon": "assets/icons/xmas/icon-xmas-lemon.png",
        "icon-loader-img": "assets/logo/logo-desktop.svg",
        "icon-category-specials": "assets/icons/icon-category-specials",
        "lemon-chips-stack-top": "assets/icons/lemon--chips-stack-top 1.png",
        "icon-wallet-small": "assets/icons/icon-wallet-small.svg",
        "icon-logout": "assets/icons/icon_logout.svg",
        "icon-delete": "assets/icons/icon-delete.svg",
        "bonus-excluded": "assets/icons/bonus-excluded.svg",
        "bonus-excluded-new": "assets/icons/bonus-excluded-new.svg",
        "icon-fav": "assets/luckera/icons/fav-icon.svg",
        "icon-tag-big-win": "assets/luckera/icons/star.svg",
        "icon-tag-bonus-excluded": "assets/luckera/icons/game-tag-luckera.svg",
        "icon-tag-hot": "assets/luckera/icons/hot.svg",
        "full-screen": "assets/icons/full-screen.svg",
        "vip-status-bronze":"assets/icons/lemons-levels/vip-bronze.png",
        "vip-status-silver":"assets/icons/lemons-levels/vip-silver.png",
        "vip-status-gold":"assets/icons/lemons-levels/vip-gold.png",
        "success-dialog":"assets/luckera/icons/checkmark.svg",
    },
    "orange_curacao": {
        "logo": "assets/logo/orange-logo.svg",
        "logo-desktop": "assets/logo/orange-logo.svg",
        "full-logo": "assets/logo/orange-logo.svg",
        "title-substitute": "Orange Casino",

    },
    "luckera": {
        "logo": "assets/logo/luckera-logo.svg",
        "logo-desktop": "assets/luckera/desktop-logo.svg",
        "logo-mobile": "assets/luckera/desktop-logo.svg",
        "full-logo": "assets/logo/luckera-logo.svg",
        "icon-loader-img": "assets/luckera/desktop-logo.svg",
        "title-substitute": "Luckera Casino",
        "icon-bonus-wallet": "assets/luckera/icons/bonus.svg",
        "icon-doller": "assets/luckera/icons/doller-icon.svg",
        "doller-symbol": "assets/luckera/icons/doller-symbol.svg",
        "icon-top-menu": "assets/luckera/icons/left.svg",
        "icon-down-arrow": "assets/luckera/icons/dropdown-icon.svg",
        "icon-right": "assets/luckera/icons/arrow-right.svg",
        "icon-remove": "assets/luckera/icons/icon-delete.svg",
        "icon-exclamation": "assets/luckera/icons/icon-exclamation.svg",
        "icon-close": "assets/luckera/signup/close.svg",
        "icon-bonus-drop": "assets/luckera/icons/icon-star.svg",
        "icon-upload": "assets/luckera/icons/icon-upload.svg",
        "upload-docs-icon": "assets/luckera/icons/empty-inbox.png", 
        "game-history-not-found":"assets/luckera/icons/search-not-found.svg",
        "operator-icon":"assets/icons/icon-operators.svg",
        "games-icon":"assets/luckera/icons/games.svg",
        "luckera-casino-icon":"assets/luckera/icons/casino.svg",
        "search-icon":"assets/luckera/icons/search.svg",
        "profile-icon":"assets/luckera/icons/profile-icon.svg",
        "level-1-icon":"assets/luckera/icons/level-icon/icon-level-1.svg",
        "plus-circle-icon":"assets/luckera/icons/plus-circle.svg",
        "close-icon":"assets/luckera/icons/close-icon.png",
        "dropdown-icon":"assets/luckera/icons/dropdown-icon.svg",
        "icon-bonus-item":"assets/luckera/icons/icon-bonus-item.svg",
        "icon-daily-cashback":"assets/luckera/icons/icon-daily-cashback.svg",
        "icon-number":"assets/luckera/icons/icon-number.svg",
        "icon-cashback":"assets/luckera/icons/icon-cashback.svg",
        "bonus-wallet-icon":"assets/luckera/icons/bonus-wallet.svg",
        "bonus-wallet-disable":"assets/luckera/icons/bonus-wallet-disable.svg",
        "icon-wallet-disable":"assets/luckera/icons/icon-wallet-disable.svg",
        "disable-bonus":"assets/luckera/icons/disable-bonus.svg",
        "icon-bonus":"assets/luckera/icons/icon-bonus.svg",
        "icon-mybonus-icon-mobile":"assets/luckera/icons/mybonus-icon-mobile.svg",
        "profile-my-bonus":"assets/luckera/icons/profile-my-bonus.svg",
        "profile-my-games":"assets/luckera/icons/profile-my-games.svg",
        "edit-profile-icon":"assets/luckera/icons/editprofileicon.svg",
        "change-password-icon":"assets/luckera/icons/profile-change-password.svg",
        "icon-info":"assets/luckera/icons/icon-info.svg",
        "icon-info-white": "assets/luckera/icons/icon-info-white.svg",
        "gold-icon-info": "assets/luckera/icons/icon-tourney-info.svg",
        "home-icon":"assets/luckera/icons/lobby-home.svg",
        "slots-icon":"assets/luckera/icons/icon-slots.svg",
        "casino-icon":"assets/luckera/icons/icon-casino.svg",
        "change-password":"assets/luckera/icons/change-password.svg",
        "pswd-eye-off":"assets/luckera/icons/pswd-eye-off.svg",
        "pswd-eye-on":"assets/luckera/icons/pswd-eye-on.svg",
        "login-img":"assets/luckera/signup/login.svg",
        "inbox-icon":"assets/luckera/icons/inbox.svg",
        "signup-close":"assets/luckera/signup/close.svg",
        "signup-envelope":"assets/luckera/signup/envelope.svg",
        "signup-step-1":"assets/luckera/signup/step-one.svg",
        "signup-step-2":"assets/luckera/signup/step-two.svg",
        "wheel-rotate":"assets/luckera/gamification/wheel/wheel-rotate-desktop.svg",
        "wheel-static":"assets/luckera/gamification/wheel/wheel-static-desktop.svg",
        "promo-ticket":"assets/luckera/icons/promo-ticket.png",
        "icon-promo-code":"assets/luckera/icons/yellow-icon-promo-code.svg",
        "redeem-promo-tick":"assets/luckera/icons/redeem-promo-tick.svg",
        "down-arrow":"assets/luckera/icons/down-arrow.svg",
        "404-not-found":"assets/luckera/icons/404.svg", 
        "404-not-found-mobile":"assets/luckera/icons/404-mobile.svg",
        "icon-deposit":"assets/luckera/icons/icon-deposit.svg",
        "loader-image":"assets/luckera/loader-image.svg",
        "category-specials-icon":"assets/luckera/icons/icon-category-specials.svg",
        "tournament-games":"assets/luckera/tournament/games.svg", 
        "mission-icon":"assets/luckera/icons/icon-mission.svg",
        "support-icon":"assets/luckera/icons/support-luckera.svg",
        "faq-icon":"assets/luckera/icons/faq-luckera.svg",
        "self-exclusion-icon":"assets/luckera/icons/self-exclusion-luckera.svg",
        "icon-category-tournaments":"assets/luckera/tournament/icon-category-tournaments.svg",
        "icon-category-tournament-live":"assets/luckera/tournament/icon-category-tournament-live.svg",
        "icon-category-tournament-scheduled":"assets/luckera/tournament/icon-category-tournament-scheduled.svg",
        "icon-category-tournament-finished":"assets/luckera/tournament/icon-category-tournament-finished.svg",
        "icon-tournament-type-2":"assets/luckera/tournament/icon-tournament-type-2.svg",
        "icon-games-collection-inactive":"assets/luckera/tournament/icon-games-collection-inactive.svg",
        "icon-tourney-info":"assets/luckera/tournament/icon-tourney-info.svg", 
        "icon-tourney-leaderboard":"assets/luckera/tournament/icon-tourney-leaderboard.svg",
        "icon-tourney-prices":"assets/luckera/tournament/icon-tourney-prices.svg",
        'icon-bet-coins': "assets/luckera/icons/missions/icon-bet-coins.svg",
        "icon-tourney-scoring":"assets/luckera/tournament/icon-tourney-scoring.svg",
        "icon-tourney":"assets/luckera/tournament/icon-tourney.svg", 
        "mobile-logo":"assets/luckera/mobile-logo.svg",
        "category-luckera-icon":"assets/luckera/icons/category-luckera.svg",
        "remove-fav-icon":"assets/luckera/icons/remove-fav-icon.svg",
        "icon_fav_add":"assets/luckera/icons/icon_fav_add.svg",
        "game_fav":"assets/luckera/icons/game_fav.svg",
        "search-close-icon":"assets/luckera/icons/search-close-icon.svg",
        "icon-withdrawals":"assets/luckera/icons/icon-withdrawals.svg",
        "tournament-trophy":"assets/luckera/tournament/trophy.svg",
        "icon-bonus-box":"assets/luckera/icons/icon-bonus-box.svg",
        "info-icon":"assets/luckera/icons/info.svg",
        "calendar-icon-editprofile":"assets/luckera/icons/calendar-icon-editprofile.svg",
        "upload-icon":"assets/luckera/icons/upload-icon-luckera.svg",
        "signup-icon":"assets/luckera/icons/sign-up.svg",
        "category-icon":"assets/luckera/icons/category.svg",
        "wallet-icon":"assets/luckera/icons/wallet.svg",
        "live-casino":"assets/luckera/icons/live-casino.svg",
        "warning-icon":"assets/luckera/icons/warning-icon.svg",
        "promocode-icon":"assets/luckera/icons/promocode.svg",
        "icon-dollar-symbol": "assets/luckera/icons/icon-dollar-symbol.svg",
        "icon-verified-symbol": "assets/luckera/icons/icon-verified-symbol.svg",
        "icon-dollar-symbol-disable": "assets/luckera/icons/icon-dollar-symbol-disable.svg",
        "icon-verified-symbol-disable": "assets/luckera/icons/icon-verified-symbol-disable.svg",
        "icon-default-profile": "assets/luckera/icons/icon-default-profile.svg",
        "icon-earning": "assets/luckera/icons/icon-earning.svg",
        "icon-friend-new": "assets/luckera/icons/icon-friend-new.svg",
        "banner-refer-friend": "assets/luckera/banner-refer-friend.jpg",
        "mobile-banner-refer-friend": "assets/luckera/mobile-banner-refer-friend.jpg",
        "new-add-friend": "assets/luckera/icons/new-add-friend.svg",
        "icon-easymoney-luckera": "assets/luckera/icons/icon-easymoney-luckera.svg",
        "icon-live-casino-luckera": "assets/luckera/icons/icon-live-casino-luckera.svg",
        "icon-wallet-symbol":"assets/luckera/icons/icon-price-symbol.svg",
        "icon-wallet-symbol-mob":"assets/luckera/icons/icon-price-symbol-mob.svg",
        "icon-my-games-new":"assets/luckera/icons/icon-my-games-new.svg",
        "icon-my-games-new-32x32":"assets/luckera/icons/icon-my-games-new-32x32.svg",
        "icon-last-played":"assets/luckera/icons/icon-last-played.svg",
        "upload-document-img": "assets/luckera/icons/upload-document-img.png",
        "icon-upload-doc-badge": "assets/luckera/icons/icon-upload-doc-badge.svg",
        "icon-verification-badge": "assets/luckera/icons/icon-verification-badge.svg",
        "icon-unverified-badge": "assets/luckera/icons/icon-unverified-badge.svg",
        "icon-verified-badge": "assets/luckera/icons/icon-verified-badge.svg",
        "icon-header-plus-circle":"assets/luckera/icons/icon-header-plus-circle.svg",
        "icon-bonus-wheel":"assets/luckera/icons/icon-bonus-wheel.svg",
        "pending-withdrawal":"assets/luckera/icons/pending-withdrawal.svg",
        "icon-hot-20":"assets/luckera/icons/icon-hot-20.svg",
        "icon-easy-money":"assets/luckera/icons/icon-easy-money.svg",
        "icon-cashback-symbol":"assets/luckera/icons/icon-cashback-symbol.svg",
        "icon-payment-history":"assets/luckera/icons/icon-payment-history.svg",
        "icon-easywin-luckera":"assets/luckera/icons/icon-easywin-luckera.svg",
        "icon-easy-win-light-luckera":"assets/luckera/icons/icon-easy-win-light-luckera.svg",
        "icon-jackpot":"assets/luckera/icons/jackpot-icon.svg",
        "icon-green-info":"assets/luckera/icons/icon-info-jackpot.svg",
        "jackpot-img":"assets/luckera/jackpot-image.svg",
        "jackpot-info-image":"assets/luckera/jackpot-info-image.svg",
        "icon-provider-new":"assets/luckera/icons/icon-provider-new.svg",
        "signup-banner":"assets/luckera/signup/signup-banner.svg",
        "mission-game":"assets/luckera/icons/missions/icon-games-collection.svg"
    }
}

